<template>
  <div>
    <v-tooltip open-delay="500" top>
      <template #activator="{ on, attrs }">
        <v-btn :disabled="disabled" x-small icon v-bind="attrs" v-on="on" @click.stop="mudarEstadoDialog">
          <v-icon small v-text="'mdi-information-outline'" />
        </v-btn>
      </template>
      <span>Detalhamento das últimas compras</span>
    </v-tooltip>

    <v-dialog
      v-model="dialog_ativo"
      fullscreen
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="#042333">
          <v-btn 
            icon 
            dark 
            class="mr-5" 
            @click.stop="mudarEstadoDialog"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <v-toolbar-title>Últimas compras</v-toolbar-title>

          <v-spacer />

          <ExportarExcel 
            :filtros="{ id_grupo: filtros.grupo, id_categoria: filtros.idcategoria, data_referencia: data_referencia }" 
            :headers="JSON.stringify(headers)"
            url_relatorio="relatorios/compras/materia-prima/vendas-mensal"
          />
        </v-toolbar>

        <v-card-text class="px-0 py-0">
          <slot name="topo-corpo" />

          <v-tabs v-model="data_referencia" background-color="#f8f7f7" show-arrows class="mt-n1">
            <v-tab v-for="mes in ULTIMOS_12_MESES" :key="mes.data_referencia" :href="`#${mes.data_referencia}`">
              {{ mes.descricao }}
            </v-tab>
          </v-tabs>

          <v-data-table
            height="calc(100vh - 210px)"
            :headers="headers"
            :items="vendas_mes_selecionado"
            class="ml-2"
            :items-per-page="-1"
            fixed-header
          >
            <template #item.qtde_pa="{item}">
              {{ Helpers.formatarValor(item.qtde_pa) }}
            </template>

            <template #item.qtde_materia_prima="{item}">
              {{ Helpers.formatarValor(item.qtde_pa * item.peso_pa) }}
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { buscarUltimasVendasMensais } from "@/api/compras/MateriaPrima.js";
import { logout, nomeMeses } from "@/helpers";
import ExportarExcel from '@/components/utils/ExportarExcel/PorFiltroDeDataInicialEFinal.vue';

export default {
  name: "VendasUltimosMeses",
  components: { ExportarExcel },
  props: {
    filtros: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
    dialog_ativo: false,
    data_referencia: null,
    data_atual: null,
    headers: [
      { text: "Produto", value: "produto" },
      { text: "Filial", value: "filial" },
      { text: "Id pedido", value: "idconsumo" },
      { text: "Data de emissao", value: "emissao" },
      { text: "Horário", value: "horariomov" },
      { text: "Quantidade PA", value: "qtde_pa" },
      { text: "Quantidade MP", value: "qtde_materia_prima" },
    ],
    vendas_mes_selecionado: [],
  }),
  computed: {
    ULTIMOS_12_MESES() {
      if (!this.data_atual || !this.data_atual.length) return [];

      let [_, mes, ano] = this.data_atual.split('/');
      mes = parseInt(mes);

      let meses = [];

      for (let i = 0; i < 12; i++) {
        meses.push({
          data_referencia: '01/'.concat(`${mes}`.padStart(2, 0), '/', ano),
          descricao: `${nomeMeses[mes - 1] || mes}/${ano}`,
        });

        if (mes === 1) {
          mes = 12;
          ano--;
        } else {
          mes--;
        }
      }

      return meses.reverse();
    }
  },
  watch: {
    data_atual() {
      if (!this.data_atual || !this.data_atual.length) return;

      this.data_referencia = this.data_atual;
    },
    data_referencia() {
      if (this.data_referencia !== this.data_atual) {
        this.vendas_mes_selecionado = [];
        this.buscarUltimasVendasMensais();
      }
    }
  },
  methods: {
    mudarEstadoDialog() {
      this.dialog_ativo = !this.dialog_ativo;

      if (this.dialog_ativo) {
        this.data_referencia = null;
        this.data_atual = null;
        this.vendas_mes_selecionado = [];
        this.buscarUltimasVendasMensais();
      }
    },
    buscarUltimasVendasMensais() {
      const parametros = {
        id_grupo: this.filtros.grupo,
        id_categoria: this.filtros.idcategoria,
        data_referencia: this.data_referencia
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        buscarUltimasVendasMensais(parametros)
          .then(resp => {
            this.data_atual = resp.data_atual;
            this.vendas_mes_selecionado = resp.vendas_mes;
          })
          .catch(logout)
      );
    }
  }
}
</script>

<style scoped>
</style>
